const Privacy = () => (
  <div id="privacy">
    <style
      dangerouslySetInnerHTML={{
        __html:
          '\n\n/* Font Definitions */\n\n/* Style Definitions */\np.MsoNormal, li.MsoNormal, div.MsoNormal {\n  margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nh1 {\n  mso-style-link:"Heading 1 Char";\n   margin-top:12.0pt;\n   margin-right:0in;\n   margin-bottom:3.0pt;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   border:none;\n   padding:0in;\n   font-size:16.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n}\nh2 {\n  mso-style-link:"Heading 2 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:13.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nh3 {\n  mso-style-link:"Heading 3 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nh4 {\n  mso-style-link:"Heading 4 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n   font-style:italic;\n}\nh5 {\n  mso-style-link:"Heading 5 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n}\nh6 {\n  mso-style-link:"Heading 6 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n   font-style:italic;\n}\np.MsoHeading7, li.MsoHeading7, div.MsoHeading7 {\n  mso-style-link:"Heading 7 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-style:italic;\n}\np.MsoHeading8, li.MsoHeading8, div.MsoHeading8 {\n  mso-style-link:"Heading 8 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:10.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoHeading9, li.MsoHeading9, div.MsoHeading9 {\n  mso-style-link:"Heading 9 Char";\n   margin-top:10.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:0in;\n   page-break-after:avoid;\n   font-size:10.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-style:italic;\n}\np.MsoToc1, li.MsoToc1, div.MsoToc1 {\n  margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:5.0pt;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoCommentText, li.MsoCommentText, div.MsoCommentText {\n  mso-style-link:"Comment Text Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:10.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoHeader, li.MsoHeader, div.MsoHeader {\n  mso-style-link:"Header Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoFooter, li.MsoFooter, div.MsoFooter {\n  mso-style-link:"Footer Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MsoFootnoteReference {\n  color:black;\n   vertical-align:super;\n}\nspan.MsoCommentReference {\n  color:black;\n}\nspan.MsoLineNumber {\n  color:black;\n}\nspan.MsoPageNumber {\n  color:black;\n}\nspan.MsoEndnoteReference {\n  color:black;\n   vertical-align:super;\n}\np.MsoTitle, li.MsoTitle, div.MsoTitle {\n  mso-style-link:"Title Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\na:link, span.MsoHyperlink {\n  color:black;\n   text-decoration:none;\n}\na:visited, span.MsoHyperlinkFollowed {\n  color:black;\n   text-decoration:underline;\n}\nstrong {\n  color:black;\n}\nem {\n  color:black;\n}\np.MsoDocumentMap, li.MsoDocumentMap, div.MsoDocumentMap {\n  mso-style-link:"Document Map Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:8.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np {\n  margin-right:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n}\nacronym {\n  color:black;\n}\ncite {\n  color:black;\n}\ncode {\n  font-family:Consolas;\n   color:black;\n}\ndfn {\n  color:black;\n}\nkbd {\n  font-family:Consolas;\n   color:black;\n}\nsamp {\n  font-family:Consolas;\n   color:black;\n}\ntt {\n  font-family:Consolas;\n   color:black;\n}\nvar {\n  color:black;\n}\np.MsoCommentSubject, li.MsoCommentSubject, div.MsoCommentSubject {\n  mso-style-link:"Comment Subject Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:10.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.MsoAcetate, li.MsoAcetate, div.MsoAcetate {\n  mso-style-link:"Balloon Text Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:8.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MsoPlaceholderText {\n  color:black;\n}\np.MsoRMPane, li.MsoRMPane, div.MsoRMPane {\n  margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph {\n  mso-style-link:"List Paragraph Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst {\n  mso-style-link:"List Paragraph Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle {\n  mso-style-link:"List Paragraph Char";\n   margin-top:0in;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast {\n  mso-style-link:"List Paragraph Char";\n   margin-top:0in;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MsoSubtleEmphasis {\n  color:black;\n   font-style:italic;\n}\nspan.MsoIntenseEmphasis {\n  color:black;\n   font-weight:bold;\n   font-style:italic;\n}\nspan.MsoSubtleReference {\n  font-variant:small-caps;\n   color:black;\n   text-decoration:underline;\n}\nspan.MsoIntenseReference {\n  font-variant:small-caps;\n   color:black;\n   letter-spacing:.25pt;\n   font-weight:bold;\n   text-decoration:underline;\n}\nspan.MsoBookTitle {\n  font-variant:small-caps;\n   color:black;\n   letter-spacing:.25pt;\n   font-weight:bold;\n}\nspan.Heading1Char {\n  mso-style-name:"Heading 1 Char";\n   mso-style-link:"Heading 1";\n   color:black;\n}\np.AttachmentHeading, li.AttachmentHeading, div.AttachmentHeading {\n  mso-style-name:"Attachment Heading";\n   mso-style-link:"Attachment Heading Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.AttachmentName, li.AttachmentName, div.AttachmentName {\n  mso-style-name:"Attachment Name";\n   mso-style-link:"Attachment Name Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   text-transform:uppercase;\n   font-weight:bold;\n}\np.CoverSheetAsOf, li.CoverSheetAsOf, div.CoverSheetAsOf {\n  mso-style-name:"Cover Sheet As Of";\n   mso-style-link:"Cover Sheet As Of Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.CoverSheetHeading, li.CoverSheetHeading, div.CoverSheetHeading {\n  mso-style-name:"Cover Sheet Heading";\n   mso-style-link:"Cover Sheet Heading Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.CoverSheetParty, li.CoverSheetParty, div.CoverSheetParty {\n  mso-style-name:"Cover Sheet Party";\n   mso-style-link:"Cover Sheet Party Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.Juris, li.Juris, div.Juris {\n  mso-style-name:Juris;\n   mso-style-link:"Juris Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.CoverSheetStaticAnd, li.CoverSheetStaticAnd, div.CoverSheetStaticAnd {\n  mso-style-name:"Cover Sheet Static And";\n   mso-style-link:"Cover Sheet Static And Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.CoverSheetStaticBetween, li.CoverSheetStaticBetween, div.CoverSheetStaticBetween {\n  mso-style-name:"Cover Sheet Static Between";\n   mso-style-link:"Cover Sheet Static Between Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.JurisChar {\n  mso-style-name:"Juris Char";\n   mso-style-link:Juris;\n   color:black;\n}\np.CoverSheetStaticDate, li.CoverSheetStaticDate, div.CoverSheetStaticDate {\n  mso-style-name:"Cover Sheet Static Date";\n   mso-style-link:"Cover Sheet Static Date Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.PageBrk, li.PageBrk, div.PageBrk {\n  mso-style-name:"Page Brk";\n   mso-style-link:"Page Brk Char";\n   margin-top:12.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-align:center;\n   font-size:10.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFPara-Clause, li.SFPara-Clause, div.SFPara-Clause {\n  mso-style-name:"SF Para - Clause";\n   mso-style-link:"SF Para - Clause Char";\n   margin-top:12.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParasubclause1, li.SFParasubclause1, div.SFParasubclause1 {\n  mso-style-name:"SF Para subclause 1";\n   mso-style-link:"SF Para subclause 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.5in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParasubclause2, li.SFParasubclause2, div.SFParasubclause2 {\n  mso-style-name:"SF Para subclause 2";\n   mso-style-link:"SF Para subclause 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParasubclause3, li.SFParasubclause3, div.SFParasubclause3 {\n  mso-style-name:"SF Para subclause 3";\n   mso-style-link:"SF Para subclause 3 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.5in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.SFParasubclause1Char {\n  mso-style-name:"SF Para subclause 1 Char";\n   mso-style-link:"SF Para subclause 1";\n   font-family: "Exo 2";\n   color:black;\n}\np.SectionHeading, li.SectionHeading, div.SectionHeading {\n  mso-style-name:"Section Heading";\n   mso-style-link:"Section Heading Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.SigBlockmsg, li.SigBlockmsg, div.SigBlockmsg {\n  mso-style-name:"Sig Block msg\\.";\n   mso-style-link:"Sig Block msg\\. Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n   text-transform:uppercase;\n}\nspan.ResourceTypeChar {\n  mso-style-name:"Resource Type Char";\n   mso-style-link:"Resource Type";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.AbstractChar {\n  mso-style-name:"Abstract Char";\n   mso-style-link:Abstract;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DescriptiveHeadingChar {\n  mso-style-name:"DescriptiveHeading Char";\n   mso-style-link:DescriptiveHeading;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.TitleChar {\n  mso-style-name:"Title Char";\n   mso-style-link:Title;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.AuthoringGroupChar {\n  mso-style-name:"Authoring Group Char";\n   mso-style-link:"Authoring Group";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.InternalAuthorChar {\n  mso-style-name:"Internal Author Char";\n   mso-style-link:"Internal Author";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.IgnoredSpacingChar {\n  mso-style-name:"Ignored Spacing Char";\n   mso-style-link:"Ignored Spacing";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MaintenanceEditorChar {\n  mso-style-name:"Maintenance Editor Char";\n   mso-style-link:"Maintenance Editor";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.IgnoredTemplateTextChar {\n  mso-style-name:"Ignored Template Text Char";\n   mso-style-link:"Ignored Template Text";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.AttachmentHeadingChar {\n  mso-style-name:"Attachment Heading Char";\n   mso-style-link:"Attachment Heading";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.CoverSheetAsOfChar {\n  mso-style-name:"Cover Sheet As Of Char";\n   mso-style-link:"Cover Sheet As Of";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.BalloonTextChar {\n  mso-style-name:"Balloon Text Char";\n   mso-style-link:"Balloon Text";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.CoverSheetHeadingChar {\n  mso-style-name:"Cover Sheet Heading Char";\n   mso-style-link:"Cover Sheet Heading";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.CoverSheetPartyChar {\n  mso-style-name:"Cover Sheet Party Char";\n   mso-style-link:"Cover Sheet Party";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.CoverSheetStaticAndChar {\n  mso-style-name:"Cover Sheet Static And Char";\n   mso-style-link:"Cover Sheet Static And";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.CoverSheetStaticBetweenChar {\n  mso-style-name:"Cover Sheet Static Between Char";\n   mso-style-link:"Cover Sheet Static Between";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.CoverSheetStaticDateChar {\n  mso-style-name:"Cover Sheet Static Date Char";\n   mso-style-link:"Cover Sheet Static Date";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.AttachmentNameChar {\n  mso-style-name:"Attachment Name Char";\n   mso-style-link:"Attachment Name";\n   font-family: "Exo 2";\n   color:black;\n   text-transform:uppercase;\n   font-weight:bold;\n}\nspan.PageBrkChar {\n  mso-style-name:"Page Brk Char";\n   mso-style-link:"Page Brk";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DocumentTitleChar {\n  mso-style-name:"Document Title Char";\n   mso-style-link:"Document Title";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.SigBlockmsgChar {\n  mso-style-name:"Sig Block msg\\. Char";\n   mso-style-link:"Sig Block msg\\.";\n   font-family: "Exo 2";\n   color:black;\n   text-transform:uppercase;\n}\nspan.TemplateTypeChar {\n  mso-style-name:"Template Type Char";\n   mso-style-link:"Template Type";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DraftingNoteTitleChar {\n  mso-style-name:"Drafting Note Title Char";\n   mso-style-link:"Drafting Note Title";\n   color:black;\n   font-weight:bold;\n}\nspan.HeadingLevel1Char {\n  mso-style-name:"Heading Level 1 Char";\n   mso-style-link:"Heading Level 1";\n   color:black;\n   font-weight:bold;\n}\nspan.HeaderChar {\n  mso-style-name:"Header Char";\n   mso-style-link:Header;\n   color:black;\n}\nspan.FooterChar {\n  mso-style-name:"Footer Char";\n   mso-style-link:Footer;\n   color:black;\n}\nspan.SectionHeadingChar {\n  mso-style-name:"Section Heading Char";\n   mso-style-link:"Section Heading";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.ListParagraphChar {\n  mso-style-name:"List Paragraph Char";\n   mso-style-link:"List Paragraph";\n   color:black;\n}\nspan.ResourceHistoryTitleChar {\n  mso-style-name:"Resource History Title Char";\n   mso-style-link:"Resource History Title";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.ResourceHistoryAuthor, li.ResourceHistoryAuthor, div.ResourceHistoryAuthor {\n  mso-style-name:"Resource History Author";\n   mso-style-link:"Resource History Author Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ResourceHistoryDateChar {\n  mso-style-name:"Resource History Date Char";\n   mso-style-link:"Resource History Date";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ResourceHistoryAuthorChar {\n  mso-style-name:"Resource History Author Char";\n   mso-style-link:"Resource History Author";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ResourceHistoryDescChar {\n  mso-style-name:"Resource History Desc Char";\n   mso-style-link:"Resource History Desc";\n   font-family: "Exo 2";\n   color:black;\n}\np.DefinedTermPara, li.DefinedTermPara, div.DefinedTermPara {\n  mso-style-name:"Defined Term Para";\n   mso-style-link:"Defined Term Para Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DefinedTermParaChar {\n  mso-style-name:"Defined Term Para Char";\n   mso-style-link:"Defined Term Para";\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause1, li.LFParasubclause1, div.LFParasubclause1 {\n  mso-style-name:"LF Para subclause 1";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause2, li.LFParasubclause2, div.LFParasubclause2 {\n  mso-style-name:"LF Para subclause 2";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.5in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause3, li.LFParasubclause3, div.LFParasubclause3 {\n  mso-style-name:"LF Para subclause 3";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause4, li.LFParasubclause4, div.LFParasubclause4 {\n  mso-style-name:"LF Para subclause 4";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.5in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFTitle-Clause, li.LFTitle-Clause, div.LFTitle-Clause {\n  mso-style-name:"LF Title - Clause";\n   mso-style-link:"LF Title - Clause Char";\n   margin-top:.25in;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-align:center;\n   text-indent:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.Title-Subclause1 {\n  mso-style-name:"Title - Subclause 1";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n   text-decoration:none none;\n   vertical-align:baseline;\n}\np.SLPara-Clause, li.SLPara-Clause, div.SLPara-Clause {\n  mso-style-name:"SL Para - Clause";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.CustomizableHeading, li.CustomizableHeading, div.CustomizableHeading {\n  mso-style-name:"Customizable Heading";\n   mso-style-link:"Customizable Heading Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.CustomizableHeadingChar {\n  mso-style-name:"Customizable Heading Char";\n   mso-style-link:"Customizable Heading";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.LFTitle-ClauseChar {\n  mso-style-name:"LF Title - Clause Char";\n   mso-style-link:"LF Title - Clause";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.MFPara-Clause, li.MFPara-Clause, div.MFPara-Clause {\n  mso-style-name:"MF Para - Clause";\n   mso-style-link:"MF Para - Clause Char";\n   margin-top:12.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:21.55pt;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause1, li.MFParasubclause1, div.MFParasubclause1 {\n  mso-style-name:"MF Para subclause 1";\n   mso-style-link:"MF Para subclause 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.3in;\n   text-indent:.4in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause2, li.MFParasubclause2, div.MFParasubclause2 {\n  mso-style-name:"MF Para subclause 2";\n   mso-style-link:"MF Para subclause 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.7in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause3, li.MFParasubclause3, div.MFParasubclause3 {\n  mso-style-name:"MF Para subclause 3";\n   mso-style-link:"MF Para subclause 3 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.2in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause4, li.MFParasubclause4, div.MFParasubclause4 {\n  mso-style-name:"MF Para subclause 4";\n   mso-style-link:"MF Para subclause 4 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.7in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.SFParasubclause2Char {\n  mso-style-name:"SF Para subclause 2 Char";\n   mso-style-link:"SF Para subclause 2";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.SFParasubclause3Char {\n  mso-style-name:"SF Para subclause 3 Char";\n   mso-style-link:"SF Para subclause 3";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.SFPara-ClauseChar {\n  mso-style-name:"SF Para - Clause Char";\n   mso-style-link:"SF Para - Clause";\n   font-family: "Exo 2";\n   color:black;\n}\np.MemoPara-Clause, li.MemoPara-Clause, div.MemoPara-Clause {\n  mso-style-name:"Memo Para - Clause";\n   mso-style-link:"Memo Para - Clause Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MemoPara-ClauseChar {\n  mso-style-name:"Memo Para - Clause Char";\n   mso-style-link:"Memo Para - Clause";\n   color:black;\n}\np.MemoParasubclause1, li.MemoParasubclause1, div.MemoParasubclause1 {\n  mso-style-name:"Memo Para subclause 1";\n   mso-style-link:"Memo Para subclause 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MemoClauseTitle-Para, li.MemoClauseTitle-Para, div.MemoClauseTitle-Para {\n  mso-style-name:"Memo Clause Title - Para";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n   text-decoration:underline;\n}\np.RESPara-Clause, li.RESPara-Clause, div.RESPara-Clause {\n  mso-style-name:"RES Para - Clause";\n   mso-style-link:"RES Para - Clause Char";\n   margin-top:12.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.RESPara-ClauseChar {\n  mso-style-name:"RES Para - Clause Char";\n   mso-style-link:"RES Para - Clause";\n   color:black;\n}\np.RecitalClause, li.RecitalClause, div.RecitalClause {\n  mso-style-name:"Recital Clause";\n   mso-style-link:"Recital Clause Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.RecitalClauseChar {\n  mso-style-name:"Recital Clause Char";\n   mso-style-link:"Recital Clause";\n   color:black;\n}\nspan.MemoParasubclause1Char {\n  mso-style-name:"Memo Para subclause 1 Char";\n   mso-style-link:"Memo Para subclause 1";\n   color:black;\n}\nspan.MFParasubclause1Char {\n  mso-style-name:"MF Para subclause 1 Char";\n   mso-style-link:"MF Para subclause 1";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MFParasubclause2Char {\n  mso-style-name:"MF Para subclause 2 Char";\n   mso-style-link:"MF Para subclause 2";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MFParasubclause3Char {\n  mso-style-name:"MF Para subclause 3 Char";\n   mso-style-link:"MF Para subclause 3";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MFParasubclause4Char {\n  mso-style-name:"MF Para subclause 4 Char";\n   mso-style-link:"MF Para subclause 4";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.MFPara-ClauseChar {\n  mso-style-name:"MF Para - Clause Char";\n   mso-style-link:"MF Para - Clause";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DocumentMapChar {\n  mso-style-name:"Document Map Char";\n   mso-style-link:"Document Map";\n   font-family: "Exo 2";\n   color:black;\n}\np.ppcountsave, li.ppcountsave, div.ppcountsave {\n  mso-style-name:ppcountsave;\n   mso-style-link:"ppcountsave Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:7.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ppcountsaveChar {\n  mso-style-name:"ppcountsave Char";\n   mso-style-link:ppcountsave;\n   color:black;\n}\np.LFParaOptsubclause1, li.LFParaOptsubclause1, div.LFParaOptsubclause1 {\n  mso-style-name:"LF Para Opt subclause 1";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.docversion, li.docversion, div.docversion {\n  mso-style-name:docversion;\n   mso-style-link:"docversion Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:7.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.docversionChar {\n  mso-style-name:"docversion Char";\n   mso-style-link:docversion;\n   color:black;\n}\nspan.Title-Clause {\n  mso-style-name:"Title - Clause";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n   text-decoration:none none;\n   vertical-align:baseline;\n}\nspan.Title-Subclause2 {\n  mso-style-name:"Title - Subclause 2";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n   text-decoration:none none;\n   vertical-align:baseline;\n}\nspan.Title-Subclause3 {\n  mso-style-name:"Title - Subclause 3";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n   text-decoration:none none;\n   vertical-align:baseline;\n}\nspan.Title-Subclause4 {\n  mso-style-name:"Title - Subclause 4";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:normal;\n   text-decoration:none none;\n   vertical-align:baseline;\n}\np.LFParaOptsubclause2, li.LFParaOptsubclause2, div.LFParaOptsubclause2 {\n  mso-style-name:"LF Para Opt subclause 2";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.5in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParaOptsubclause3, li.LFParaOptsubclause3, div.LFParaOptsubclause3 {\n  mso-style-name:"LF Para Opt subclause 3";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.0in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParaOptsubclause4, li.LFParaOptsubclause4, div.LFParaOptsubclause4 {\n  mso-style-name:"LF Para Opt subclause 4";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.5in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFTitle-OptClause, li.LFTitle-OptClause, div.LFTitle-OptClause {\n  mso-style-name:"LF Title - Opt Clause";\n   mso-style-link:"LF Title - Opt Clause Char";\n   margin-top:.25in;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:33.1pt;\n   text-align:center;\n   text-indent:.35in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.Title-OptSubclause2 {\n  mso-style-name:"Title - Opt Subclause 2";\n   font-family: "Exo 2";\n   color:black;\n   text-transform:none;\n   border:none;\n   background:#D9D9D9;\n   font-weight:normal;\n   text-decoration:none;\n   vertical-align:baseline;\n}\nspan.Title-OptSubclause3 {\n  mso-style-name:"Title - Opt Subclause 3";\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n   background:#D9D9D9;\n   font-weight:normal;\n   text-decoration:none;\n   vertical-align:baseline;\n}\nspan.Title-OptSubclause4 {\n  mso-style-name:"Title - Opt Subclause 4";\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n   background:#D9D9D9;\n   font-weight:normal;\n   text-decoration:none;\n   vertical-align:baseline;\n}\nspan.LFTitle-OptClauseChar {\n  mso-style-name:"LF Title - Opt Clause Char";\n   mso-style-link:"LF Title - Opt Clause";\n   font-family: "Exo 2";\n   color:black;\n   background:#D9D9D9;\n   font-weight:bold;\n}\nspan.Title-OptSubclause1 {\n  mso-style-name:"Title - Opt Subclause 1";\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n   background:#D9D9D9;\n   font-weight:normal;\n   text-decoration:none none;\n   vertical-align:baseline;\n}\np.SLPara-OptClause, li.SLPara-OptClause, div.SLPara-OptClause {\n  mso-style-name:"SL Para - Opt Clause";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.25in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFPara-OptClause, li.SFPara-OptClause, div.SFPara-OptClause {\n  mso-style-name:"SF Para - Opt Clause";\n   margin-top:12.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParaOptsubclause1, li.SFParaOptsubclause1, div.SFParaOptsubclause1 {\n  mso-style-name:"SF Para Opt subclause 1";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.5in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParaOptsubclause2, li.SFParaOptsubclause2, div.SFParaOptsubclause2 {\n  mso-style-name:"SF Para Opt subclause 2";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.0in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParaOptsubclause3, li.SFParaOptsubclause3, div.SFParaOptsubclause3 {\n  mso-style-name:"SF Para Opt subclause 3";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.5in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParaOptsubclause1, li.MFParaOptsubclause1, div.MFParaOptsubclause1 {\n  mso-style-name:"MF Para Opt subclause 1";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.3in;\n   text-indent:.35in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFPara-OptClause, li.MFPara-OptClause, div.MFPara-OptClause {\n  mso-style-name:"MF Para - Opt Clause";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.25in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParaOptsubclause2, li.MFParaOptsubclause2, div.MFParaOptsubclause2 {\n  mso-style-name:"MF Para Opt subclause 2";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.7in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParaOptsubclause3, li.MFParaOptsubclause3, div.MFParaOptsubclause3 {\n  mso-style-name:"MF Para Opt subclause 3";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.2in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParaOptsubclause4, li.MFParaOptsubclause4, div.MFParaOptsubclause4 {\n  mso-style-name:"MF Para Opt subclause 4";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.7in;\n   text-indent:.45in;\n   background:#D9D9D9;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.HeadingLevel3, li.HeadingLevel3, div.HeadingLevel3 {\n  mso-style-name:"Heading Level 3";\n   mso-style-link:"Heading Level 3 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:10.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.HeadingLevel2Char {\n  mso-style-name:"Heading Level 2 Char";\n   mso-style-link:"Heading Level 2";\n   color:black;\n   font-weight:bold;\n}\nspan.HeadingLevel3Char {\n  mso-style-name:"Heading Level 3 Char";\n   mso-style-link:"Heading Level 3";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.BlockQuote, li.BlockQuote, div.BlockQuote {\n  mso-style-name:"Block Quote";\n   mso-style-link:"Block Quote Char";\n   margin-top:6.0pt;\n   margin-right:.5in;\n   margin-bottom:6.0pt;\n   margin-left:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.BlockQuoteChar {\n  mso-style-name:"Block Quote Char";\n   mso-style-link:"Block Quote";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.BulletList1Char {\n  mso-style-name:"Bullet List 1 Char";\n   mso-style-link:"Bullet List 1";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.BulletList2Char {\n  mso-style-name:"Bullet List 2 Char";\n   mso-style-link:"Bullet List 2";\n   font-family: "Exo 2";\n   color:black;\n}\np.LFPara-Clause-nonum, li.LFPara-Clause-nonum, div.LFPara-Clause-nonum {\n  mso-style-name:"LF Para - Clause - no num";\n   mso-style-link:"LF Para - Clause - no num Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.LFPara-Clause-nonumChar {\n  mso-style-name:"LF Para - Clause - no num Char";\n   mso-style-link:"LF Para - Clause - no num";\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause1-nonum, li.LFParasubclause1-nonum, div.LFParasubclause1-nonum {\n  mso-style-name:"LF Para subclause 1 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause2-nonum, li.LFParasubclause2-nonum, div.LFParasubclause2-nonum {\n  mso-style-name:"LF Para subclause 2 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.5in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause3-nonum, li.LFParasubclause3-nonum, div.LFParasubclause3-nonum {\n  mso-style-name:"LF Para subclause 3 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.05in;\n   text-indent:.95in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.LFParasubclause4-nonum, li.LFParasubclause4-nonum, div.LFParasubclause4-nonum {\n  mso-style-name:"LF Para subclause 4 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.5in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.LinkManual {\n  mso-style-name:"Link \\(Manual\\)";\n   font-family: "Exo 2";\n   color:black;\n   text-decoration:none;\n}\np.List-LowerAlphaListLevel1, li.List-LowerAlphaListLevel1, div.List-LowerAlphaListLevel1 {\n  mso-style-name:"List - Lower Alpha List Level 1";\n   mso-style-link:"List - Lower Alpha List Level 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.5in;\n   text-indent:-.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.List-LowerAlphaListLevel2, li.List-LowerAlphaListLevel2, div.List-LowerAlphaListLevel2 {\n  mso-style-name:"List - Lower Alpha List Level 2";\n   mso-style-link:"List - Lower Alpha List Level 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.8in;\n   text-indent:-.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.List-LowerRomanListLevel1, li.List-LowerRomanListLevel1, div.List-LowerRomanListLevel1 {\n  mso-style-name:"List - Lower Roman List Level 1";\n   mso-style-link:"List - Lower Roman List Level 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.5in;\n   text-indent:-.2in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.List-LowerRomanListLevel2, li.List-LowerRomanListLevel2, div.List-LowerRomanListLevel2 {\n  mso-style-name:"List - Lower Roman List Level 2";\n   mso-style-link:"List - Lower Roman List Level 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.8in;\n   text-indent:-.2in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.List-NumberedListLevel1, li.List-NumberedListLevel1, div.List-NumberedListLevel1 {\n  mso-style-name:"List - Numbered List Level 1";\n   mso-style-link:"List - Numbered List Level 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.5in;\n   text-indent:-.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.List-UpperAlphaListLevel1, li.List-UpperAlphaListLevel1, div.List-UpperAlphaListLevel1 {\n  mso-style-name:"List - Upper Alpha List Level 1";\n   mso-style-link:"List - Upper Alpha List Level 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.5in;\n   text-indent:-.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.List-UpperAlphaListLevel2, li.List-UpperAlphaListLevel2, div.List-UpperAlphaListLevel2 {\n  mso-style-name:"List - Upper Alpha List Level 2";\n   mso-style-link:"List - Upper Alpha List Level 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.8in;\n   text-indent:-.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.ListParagraphLevel2, li.ListParagraphLevel2, div.ListParagraphLevel2 {\n  mso-style-name:"List Paragraph Level 2";\n   mso-style-link:"List Paragraph Level 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.8in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ListParagraphLevel1Char {\n  mso-style-name:"List Paragraph Level 1 Char";\n   mso-style-link:"List Paragraph Level 1";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ListParagraphLevel2Char {\n  mso-style-name:"List Paragraph Level 2 Char";\n   mso-style-link:"List Paragraph Level 2";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-NumberedListLevel1Char {\n  mso-style-name:"List - Numbered List Level 1 Char";\n   mso-style-link:"List - Numbered List Level 1";\n   font-family: "Exo 2";\n   color:black;\n}\np.List-NumberedListLevel2, li.List-NumberedListLevel2, div.List-NumberedListLevel2 {\n  mso-style-name:"List - Numbered List Level 2";\n   mso-style-link:"List - Numbered List Level 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.8in;\n   text-indent:-.3in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-LowerRomanListLevel1Char {\n  mso-style-name:"List - Lower Roman List Level 1 Char";\n   mso-style-link:"List - Lower Roman List Level 1";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-UpperAlphaListLevel1Char {\n  mso-style-name:"List - Upper Alpha List Level 1 Char";\n   mso-style-link:"List - Upper Alpha List Level 1";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-LowerAlphaListLevel1Char {\n  mso-style-name:"List - Lower Alpha List Level 1 Char";\n   mso-style-link:"List - Lower Alpha List Level 1";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-LowerAlphaListLevel2Char {\n  mso-style-name:"List - Lower Alpha List Level 2 Char";\n   mso-style-link:"List - Lower Alpha List Level 2";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-UpperAlphaListLevel2Char {\n  mso-style-name:"List - Upper Alpha List Level 2 Char";\n   mso-style-link:"List - Upper Alpha List Level 2";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-LowerRomanListLevel2Char {\n  mso-style-name:"List - Lower Roman List Level 2 Char";\n   mso-style-link:"List - Lower Roman List Level 2";\n   font-family: "Exo 2";\n   color:black;\n}\np.MFPara-Clause-nonum, li.MFPara-Clause-nonum, div.MFPara-Clause-nonum {\n  mso-style-name:"MF Para - Clause - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.7in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause1-nonum, li.MFParasubclause1-nonum, div.MFParasubclause1-nonum {\n  mso-style-name:"MF Para subclause 1 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.3in;\n   text-indent:.9in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause2-nonum, li.MFParasubclause2-nonum, div.MFParasubclause2-nonum {\n  mso-style-name:"MF Para subclause 2 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.7in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause3-nonum, li.MFParasubclause3-nonum, div.MFParasubclause3-nonum {\n  mso-style-name:"MF Para subclause 3 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.2in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MFParasubclause4-nonum, li.MFParasubclause4-nonum, div.MFParasubclause4-nonum {\n  mso-style-name:"MF Para subclause 4 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.7in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.PinPointRefChar {\n  mso-style-name:"PinPoint Ref Char";\n   mso-style-link:"PinPoint Ref";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.SFParasubclause1-nonum, li.SFParasubclause1-nonum, div.SFParasubclause1-nonum {\n  mso-style-name:"SF Para subclause 1 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.5in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParasubclause2-nonum, li.SFParasubclause2-nonum, div.SFParasubclause2-nonum {\n  mso-style-name:"SF Para subclause 2 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.0in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFParasubclause3-nonum, li.SFParasubclause3-nonum, div.SFParasubclause3-nonum {\n  mso-style-name:"SF Para subclause 3 - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.5in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SFPara-Clause-nonum, li.SFPara-Clause-nonum, div.SFPara-Clause-nonum {\n  mso-style-name:"SF Para - Clause - no num";\n   mso-style-link:"SF Para - Clause - no num Char";\n   margin-top:12.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:1.0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.SFPara-Clause-nonumChar {\n  mso-style-name:"SF Para - Clause - no num Char";\n   mso-style-link:"SF Para - Clause - no num";\n   font-family: "Exo 2";\n   color:black;\n}\np.SLPara-Clause-nonum, li.SLPara-Clause-nonum, div.SLPara-Clause-nonum {\n  mso-style-name:"SL Para - Clause - no num";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-indent:.65in;\n   background:white;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.PreservePara, li.PreservePara, div.PreservePara {\n  mso-style-name:"Preserve Para";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.IgnoredSmall, li.IgnoredSmall, div.IgnoredSmall {\n  mso-style-name:"Ignored Small";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:1.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.Title-OptClause {\n  mso-style-name:"Title - Opt Clause";\n   font-family: "Exo 2";\n   color:black;\n   border:none;\n   background:#D9D9D9;\n   font-weight:normal;\n   text-decoration:none none;\n   vertical-align:baseline;\n}\nspan.DefinedTermParaLevel4Char {\n  mso-style-name:"Defined Term Para Level 4 Char";\n   mso-style-link:"Defined Term Para Level 4";\n   font-family: "Exo 2";\n   color:black;\n}\np.DefinedTermParaLevel2, li.DefinedTermParaLevel2, div.DefinedTermParaLevel2 {\n  mso-style-name:"Defined Term Para Level 2";\n   mso-style-link:"Defined Term Para Level 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.3in;\n   text-indent:.4in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DefinedTermParaLevel2Char {\n  mso-style-name:"Defined Term Para Level 2 Char";\n   mso-style-link:"Defined Term Para Level 2";\n   font-family: "Exo 2";\n   color:black;\n}\np.DefinedTermParaLevel3, li.DefinedTermParaLevel3, div.DefinedTermParaLevel3 {\n  mso-style-name:"Defined Term Para Level 3";\n   mso-style-link:"Defined Term Para Level 3 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:.7in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.DefinedTermParaLevel4, li.DefinedTermParaLevel4, div.DefinedTermParaLevel4 {\n  mso-style-name:"Defined Term Para Level 4";\n   mso-style-link:"Defined Term Para Level 4 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:1.2in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DefinedTermParaLevel3Char {\n  mso-style-name:"Defined Term Para Level 3 Char";\n   mso-style-link:"Defined Term Para Level 3";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.List-NumberedListLevel2Char {\n  mso-style-name:"List - Numbered List Level 2 Char";\n   mso-style-link:"List - Numbered List Level 2";\n   font-family: "Exo 2";\n   color:black;\n}\np.BlankPara, li.BlankPara, div.BlankPara {\n  mso-style-name:"Blank Para";\n   mso-style-link:"Blank Para Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.BlankParaChar {\n  mso-style-name:"Blank Para Char";\n   mso-style-link:"Blank Para";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.DocumentTypeChar {\n  mso-style-name:"Document Type Char";\n   mso-style-link:"Document Type";\n   font-family: "Exo 2";\n   color:black;\n}\np.LetterheadTitle, li.LetterheadTitle, div.LetterheadTitle {\n  mso-style-name:"Letterhead Title";\n   mso-style-link:"Letterhead Title Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-align:center;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.LetterheadTitleChar {\n  mso-style-name:"Letterhead Title Char";\n   mso-style-link:"Letterhead Title";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.CenteredTitle, li.CenteredTitle, div.CenteredTitle {\n  mso-style-name:"Centered Title";\n   mso-style-link:"Centered Title Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.CenteredTitleChar {\n  mso-style-name:"Centered Title Char";\n   mso-style-link:"Centered Title";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.LinkExclude {\n  mso-style-name:"Link Exclude";\n   font-family: "Exo 2";\n   color:black;\n}\np.PreserveCover, li.PreserveCover, div.PreserveCover {\n  mso-style-name:"Preserve Cover";\n   mso-style-link:"Preserve Cover Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.PreserveCoverChar {\n  mso-style-name:"Preserve Cover Char";\n   mso-style-link:"Preserve Cover";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ParaFirst-lineIndentChar {\n  mso-style-name:"Para First-line Indent Char";\n   mso-style-link:"Para First-line Indent";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.CommentTextChar {\n  mso-style-name:"Comment Text Char";\n   mso-style-link:"Comment Text";\n   color:black;\n}\nspan.CommentSubjectChar {\n  mso-style-name:"Comment Subject Char";\n   mso-style-link:"Comment Subject";\n   color:black;\n   font-weight:bold;\n}\np.IgnoredSpacing, li.IgnoredSpacing, div.IgnoredSpacing {\n  mso-style-name:"Ignored Spacing";\n   mso-style-link:"Ignored Spacing Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.DescriptiveHeading, li.DescriptiveHeading, div.DescriptiveHeading {\n  mso-style-name:DescriptiveHeading;\n   mso-style-link:"DescriptiveHeading Char";\n   margin-top:.25in;\n   margin-right:0in;\n   margin-bottom:.25in;\n   margin-left:0in;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.TemplateType, li.TemplateType, div.TemplateType {\n  mso-style-name:"Template Type";\n   mso-style-link:"Template Type Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.DocumentType, li.DocumentType, div.DocumentType {\n  mso-style-name:"Document Type";\n   mso-style-link:"Document Type Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.ResourceType, li.ResourceType, div.ResourceType {\n  mso-style-name:"Resource Type";\n   mso-style-link:"Resource Type Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.InternalAuthor, li.InternalAuthor, div.InternalAuthor {\n  mso-style-name:"Internal Author";\n   mso-style-link:"Internal Author Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.MaintenanceEditor, li.MaintenanceEditor, div.MaintenanceEditor {\n  mso-style-name:"Maintenance Editor";\n   mso-style-link:"Maintenance Editor Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.AuthoringGroup, li.AuthoringGroup, div.AuthoringGroup {\n  mso-style-name:"Authoring Group";\n   mso-style-link:"Authoring Group Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.IgnoredTemplateText, li.IgnoredTemplateText, div.IgnoredTemplateText {\n  mso-style-name:"Ignored Template Text";\n   mso-style-link:"Ignored Template Text Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.InternalTOC, li.InternalTOC, div.InternalTOC {\n  mso-style-name:"Internal TOC";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.ResourceHistoryTitle, li.ResourceHistoryTitle, div.ResourceHistoryTitle {\n  mso-style-name:"Resource History Title";\n   mso-style-link:"Resource History Title Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.ResourceHistoryDate, li.ResourceHistoryDate, div.ResourceHistoryDate {\n  mso-style-name:"Resource History Date";\n   mso-style-link:"Resource History Date Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.ResourceHistoryDesc, li.ResourceHistoryDesc, div.ResourceHistoryDesc {\n  mso-style-name:"Resource History Desc";\n   mso-style-link:"Resource History Desc Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.Abstract, li.Abstract, div.Abstract {\n  mso-style-name:Abstract;\n   mso-style-link:"Abstract Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.PinPointRef, li.PinPointRef, div.PinPointRef {\n  mso-style-name:"PinPoint Ref";\n   mso-style-link:"PinPoint Ref Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:9.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.DraftingNoteTitle, li.DraftingNoteTitle, div.DraftingNoteTitle {\n  mso-style-name:"Drafting Note Title";\n   mso-style-link:"Drafting Note Title Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:24.0pt;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.HeadingLevel1, li.HeadingLevel1, div.HeadingLevel1 {\n  mso-style-name:"Heading Level 1";\n   mso-style-link:"Heading Level 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.Paragraph, li.Paragraph, div.Paragraph {\n  mso-style-name:Paragraph;\n   mso-style-link:"Paragraph Char1";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.BulletList1, li.BulletList1, div.BulletList1 {\n  mso-style-name:"Bullet List 1";\n   mso-style-link:"Bullet List 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.5in;\n   text-indent:-.25in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.HeadingLevel2, li.HeadingLevel2, div.HeadingLevel2 {\n  mso-style-name:"Heading Level 2";\n   mso-style-link:"Heading Level 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:11.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.BulletList2, li.BulletList2, div.BulletList2 {\n  mso-style-name:"Bullet List 2";\n   mso-style-link:"Bullet List 2 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.75in;\n   text-indent:-.25in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.DocumentTitle, li.DocumentTitle, div.DocumentTitle {\n  mso-style-name:"Document Title";\n   mso-style-link:"Document Title Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:12.0pt;\n   margin-left:0in;\n   text-align:center;\n   font-size:16.0pt;\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\np.ParaFirst-lineIndent, li.ParaFirst-lineIndent, div.ParaFirst-lineIndent {\n  mso-style-name:"Para First-line Indent";\n   mso-style-link:"Para First-line Indent Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-indent:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.ListParagraphLevel1, li.ListParagraphLevel1, div.ListParagraphLevel1 {\n  mso-style-name:"List Paragraph Level 1";\n   mso-style-link:"List Paragraph Level 1 Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:6.0pt;\n   margin-left:.5in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.Heading2Char {\n  mso-style-name:"Heading 2 Char";\n   mso-style-link:"Heading 2";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.Heading3Char {\n  mso-style-name:"Heading 3 Char";\n   mso-style-link:"Heading 3";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n}\nspan.Heading4Char {\n  mso-style-name:"Heading 4 Char";\n   mso-style-link:"Heading 4";\n   font-family: "Exo 2";\n   color:black;\n   font-weight:bold;\n   font-style:italic;\n}\nspan.Heading5Char {\n  mso-style-name:"Heading 5 Char";\n   mso-style-link:"Heading 5";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.Heading6Char {\n  mso-style-name:"Heading 6 Char";\n   mso-style-link:"Heading 6";\n   font-family: "Exo 2";\n   color:black;\n   font-style:italic;\n}\nspan.Heading7Char {\n  mso-style-name:"Heading 7 Char";\n   mso-style-link:"Heading 7";\n   font-family: "Exo 2";\n   color:black;\n   font-style:italic;\n}\nspan.Heading8Char {\n  mso-style-name:"Heading 8 Char";\n   mso-style-link:"Heading 8";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.Heading9Char {\n  mso-style-name:"Heading 9 Char";\n   mso-style-link:"Heading 9";\n   font-family: "Exo 2";\n   color:black;\n   font-style:italic;\n}\nspan.ParagraphChar {\n  mso-style-name:"Paragraph Char";\n   font-family: "Exo 2";\n   color:black;\n}\np.Para, li.Para, div.Para {\n  mso-style-name:Para;\n   mso-style-link:"Para Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ParaChar {\n  mso-style-name:"Para Char";\n   mso-style-link:Para;\n   font-family: "Exo 2";\n   color:black;\n}\np.AttorneyName, li.AttorneyName, div.AttorneyName {\n  mso-style-name:"Attorney Name";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   line-height:11.35pt;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.StyleCustomizableHeadingUnderline, li.StyleCustomizableHeadingUnderline, div.StyleCustomizableHeadingUnderline {\n  mso-style-name:"Style Customizable Heading + Underline";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n   text-decoration:underline;\n}\np.E027B61024E14DDBA07128E9B0BF5D4F, li.E027B61024E14DDBA07128E9B0BF5D4F, div.E027B61024E14DDBA07128E9B0BF5D4F {\n  mso-style-name:E027B61024E14DDBA07128E9B0BF5D4F;\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:1.0in;\n   text-indent:-.25in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.E027B61024E14DDBA07128E9B0BF5D4FCxSpFirst, li.E027B61024E14DDBA07128E9B0BF5D4FCxSpFirst, div.E027B61024E14DDBA07128E9B0BF5D4FCxSpFirst {\n  mso-style-name:E027B61024E14DDBA07128E9B0BF5D4FCxSpFirst;\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:1.0in;\n   text-indent:-.25in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.E027B61024E14DDBA07128E9B0BF5D4FCxSpMiddle, li.E027B61024E14DDBA07128E9B0BF5D4FCxSpMiddle, div.E027B61024E14DDBA07128E9B0BF5D4FCxSpMiddle {\n  mso-style-name:E027B61024E14DDBA07128E9B0BF5D4FCxSpMiddle;\n   margin-top:0in;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:1.0in;\n   text-indent:-.25in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.E027B61024E14DDBA07128E9B0BF5D4FCxSpLast, li.E027B61024E14DDBA07128E9B0BF5D4FCxSpLast, div.E027B61024E14DDBA07128E9B0BF5D4FCxSpLast {\n  mso-style-name:E027B61024E14DDBA07128E9B0BF5D4FCxSpLast;\n   margin-top:0in;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:1.0in;\n   text-indent:-.25in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\np.SectionBrk, li.SectionBrk, div.SectionBrk {\n  mso-style-name:"Section Brk";\n   mso-style-link:"Section Brk Char";\n   margin-top:6.0pt;\n   margin-right:0in;\n   margin-bottom:0in;\n   margin-left:0in;\n   text-align:center;\n   font-size:10.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\nspan.SectionBrkChar {\n  mso-style-name:"Section Brk Char";\n   mso-style-link:"Section Brk";\n   font-family: "Exo 2";\n   color:black;\n}\nspan.ParagraphChar1 {\n  mso-style-name:"Paragraph Char1";\n   mso-style-link:Paragraph;\n   font-family: "Exo 2";\n   color:black;\n}\np.CE8809C36D4D4B7F892E1C03854F502B4, li.CE8809C36D4D4B7F892E1C03854F502B4, div.CE8809C36D4D4B7F892E1C03854F502B4 {\n  mso-style-name:CE8809C36D4D4B7F892E1C03854F502B4;\n   margin:0in;\n   font-size:12.0pt;\n   font-family: "Exo 2";\n   color:black;\n}\n.MsoChpDefault {\n  font-family: "Exo 2";\n}\n/* Page Definitions */\n@page WordSection1 {\n  size:8.5in 11.0in;\n   margin:1.0in 1.0in 1.0in 1.0in;\n}\ndiv.WordSection1 {\n  page:WordSection1;\n}\n/* List Definitions */\nol {\n  margin-bottom:0in;\n}\nul {\n  margin-bottom:0in;\n}\n\n',
      }}
    />

    <div className="WordSection1">
      <p className="DocumentTitle">
        <a name="a184898">Website Privacy Policy</a>
      </p>
      <p className="Paragraph">Last modified: October, 2024</p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a598115">
          <u>
            <span style={{ fontSize: '14.0pt' }}>Introduction</span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        GigSocial Inc. (<b>“Company”</b> or<b>&nbsp;”We”</b>) respects your privacy and are
        committed to protecting it through our compliance with this policy.
      </p>
      <p className="Paragraph">
        This policy describes the types of information we may collect from you or that you may
        provide when you visit the website http://www.gigsocial.com (our “<b>Website</b>”) and our
        practices for collecting, using, maintaining, protecting, and disclosing that information.
      </p>
      <p className="Paragraph">This policy applies to information we collect:</p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        On this Website.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        In email, text, and other electronic messages between you and this Website.
      </p>
      <p className="Paragraph">It does not apply to information collected by:</p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Us offline or through any other means, including on any other website operated by Company or
        any third party; or{' '}
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Any third party, including through any application or content (including advertising) that
        may link to or be accessible from or on the Website.
      </p>
      <p className="Paragraph">
        Please read this policy carefully to understand our policies and practices regarding your
        information and how we will treat it. If you do not agree with our policies and practices,
        your choice is not to use our Website. By accessing or using this Website, you agree to this
        privacy policy. This policy may change from time to time (see{' '}
        <u>
          <span style={{ color: '#002060' }}>
            <a href="#a286592">
              <u>
                <span style={{ color: '#002060' }}>Changes to Our Privacy Policy</span>
              </u>
            </a>
          </span>
        </u>
        ). Your continued use of this Website after we make changes is deemed to be acceptance of
        those changes, so please check the policy periodically for updates.{' '}
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a1019988">
          <u>
            <span style={{ fontSize: '14.0pt' }}>Children Under the Age of 13</span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        Our Website is not intended for children under 13 years of age. No one under age 13 may
        provide any information to or on the Website. We do not knowingly collect personal
        information from children under 13. If you are under 13, do not use or provide any
        information on this Website or through any of its features, or provide any information about
        yourself to us, including your name, address, telephone number, or email address. If we
        learn we have collected or received personal information from a child under 13 without
        verification of parental consent, we will delete that information. If you believe we might
        have any information from or about a child under 13, please contact us at
        support@gigsocial.com.
      </p>
      <p className="Paragraph">
        California residents under 16 years of age may have additional rights regarding the
        collection of their personal information. Please see{' '}
        <u>
          <span style={{ color: '#002060' }}>
            <a href="#a820658">
              <u>
                <span style={{ color: '#002060' }}>Your California Privacy Rights</span>
              </u>
            </a>
          </span>
        </u>
        for more information.
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a216371">
          <u>
            <span style={{ fontSize: '14.0pt' }}>
              Information We Collect About You and How We Collect It
            </span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        We collect several types of information from and about users of our Website, including
        information:
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        By which you may be personally identified, such as name, postal address, e-mail address,
        telephone number, gender, phone number, residential address, photos, videos, or any other
        identifier by which you may be contacted online or offline (“
        <b>Personal Information</b>”);
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        That is about you but individually does not identify you, such as website cookies and
        tracking features;
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        That may be used to process payments made by You, including bank details, payment card, tax
        information, and/or
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        That includes online identifiers like information about your internet connection, including
        your IP address, the equipment you use to access our Website, usage details, and your social
        media identity including without limitation handles, posts, and information about visitors
        to your profile and content; and
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Sensitive personal information about you, including your race, ethnicity, and sexual
        orientation.
      </p>

      <p className="Paragraph">We collect this information:</p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Directly from you when you provide it to us.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Automatically as you navigate through the site. Information collected automatically may
        include usage details, IP addresses, and information collected through cookies, web beacons,
        and other tracking technologies.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        From various third party entities.
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a782263">
          <span className="Title-Subclause1">
            <i>Information You Provide to Us</i>
          </span>
          &nbsp;
        </a>
      </p>
      <p className="Paragraph">The information we collect on or through our Website may include:</p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Information that you provide by filling in forms on our Website. This includes information
        provided at the time of registering to use our Website, posting material, or requesting
        further services. We may also ask you for information when you enter a contest or promotion
        sponsored by us, and when you report a problem with our Website.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Records and copies of your correspondence (including email addresses), if you contact us.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Some features of our Website will require you to provide or submit certain Personal
        Information in order to be able to use it. Some of the features and/or services that require
        you to provide Personal Information are subject to your consent (e.g., creating a user
        profile, adding your review to one of the services or products that appear on our Website,
        newsletters which may become available from time to time, promotional material and forms),
        and some will be collected upon your consent to this Privacy Policy, as described below.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Your responses to surveys that we might ask you to complete for research purposes.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Your search queries on the Website.
      </p>
      <p className="Paragraph">
        You also may provide information to be published or displayed (hereinafter, “<b>posted</b>”)
        on public areas of the Website, or transmitted to other users of the Website or third
        parties (collectively, “<b>User Contributions</b>”), including reviews of various products
        and services. Your User Contributions are posted on and transmitted to others at your own
        risk. Although we limit access to certain pages, please be aware that no security measures
        are perfect or impenetrable. Additionally, we cannot control the actions of other users of
        the Website with whom you may choose to share your User Contributions. Therefore, we cannot
        and do not guarantee that your User Contributions will not be viewed by unauthorized
        persons.
      </p>
      <p className="Paragraph">&nbsp;</p>
      <p className="Paragraph">
        <i>Information We Collect When You Make a Purchase</i>
      </p>
      <p className="Paragraph">
        <span style={{ color: '#333333', background: 'white' }}>
          When you make a purchase or attempt to make a purchase through the Website, we collect
          Personal Information from you, including your name, billing address, shipping address,
          payment information (including credit card numbers), email address, and phone number. We
          refer to this information as “Order Information.”
        </span>
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a683129">
          <span className="Title-Subclause1">
            <i>Information We Collect Through Automatic Data Collection Technologies</i>
          </span>
          <i>&nbsp; </i>
        </a>
      </p>
      <p className="Paragraph">
        As you navigate through and interact with our Website, we may use automatic data collection
        technologies to collect certain information about your equipment, browsing actions, and
        patterns, including:
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Details of your visits to our Website, including traffic data, location data, logs, and
        other communication data and the resources that you access and use on the Website.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Details of your social media activity and details of visits to your social media profiles,
        including without limitation OnlyFans, Instagram, Facebook, and TikTok, and including all
        engagement with those profiles such as views, likes, comments, and shares.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Information about your computer and internet connection, including your IP address,
        operating system, and browser type.
      </p>
      <p className="Paragraph">
        We also may use these technologies to collect information about your online activities over
        time and across third-party websites or other online services (behavioral tracking).{' '}
      </p>
      <p className="Paragraph">
        The information we collect automatically may include personal information, or we may
        maintain it or associate it with personal information we collect in other ways or receive
        from third parties. It helps us to improve our Website and to deliver a better and more
        personalized service, including by enabling us to:
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Estimate our audience size and usage patterns.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Store information about your preferences, allowing us to customize our Website according to
        your individual interests.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Speed up your searches.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        Recognize you when you return to our Website.
      </p>
      <p className="Paragraph">
        The technologies we use for this automatic data collection may include:
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <b>Cookies (or browser cookies).</b> A cookie is a small file placed on the hard drive of
        your computer. You may refuse to accept browser cookies by activating the appropriate
        setting on your browser. However, if you select this setting you may be unable to access
        certain parts of our Website. Unless you have adjusted your browser setting so that it will
        refuse cookies, our system will issue cookies when you direct your browser to our Website.{' '}
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <b>Web Beacons.</b> Pages of our the Website and our emails may contain small electronic
        files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel
        gifs) that permit the Company, for example, to count users who have visited those pages or
        opened an email and for other related website statistics (for example, recording the
        popularity of certain website content and verifying system and server integrity).{' '}
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a612118">
          <u>
            <span style={{ fontSize: '14.0pt' }}>
              Third-Party Use of Cookies and Other Tracking Technologies
            </span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        Some content or applications, including advertisements, on the Website are served by
        third-parties, including advertisers, ad networks and servers, content providers, and
        application providers. These third parties may use cookies alone or in conjunction with web
        beacons or other tracking technologies to collect information about you when you use our
        Website. The information they collect may be associated with your personal information or
        they may collect information, including personal information, about your online activities
        over time and across different websites and other online services. They may use this
        information to provide you with interest-based (behavioral) advertising or other targeted
        content.{' '}
      </p>
      <p className="Paragraph">
        We do not control these third parties’ tracking technologies or how they may be used. If you
        have any questions about an advertisement or other targeted content, you should contact the
        responsible provider directly. For information about how you can opt out of receiving
        targeted advertising from many providers, see{' '}
        <u>
          <span style={{ color: '#002060' }}>
            <a href="#a741158">
              <u>
                <span style={{ color: '#002060' }}>
                  Choices About How We Use and Disclose Your Information
                </span>
              </u>
            </a>
          </span>
        </u>
        .
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a183824">
          <u>
            <span style={{ fontSize: '14.0pt' }}>How We Use Your Information</span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        We use information that we collect about you or that you provide to us, including any
        personal information:
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To present our Website and its contents to you.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To provide you with information, products, or services that you request from us.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To fulfill any other purpose for which you provide it.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To provide you with notices about your account.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To carry out our obligations and enforce our rights arising from any contracts entered into
        between you and us.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To notify you about changes to our Website or any products or services we offer or provide
        though it.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To provide customer support.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To facilitate account management, billing and payment, order fulfillment, and service-
        related communications.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To communicate with you about promotions, sweepstakes, and other marketing and advertising
        communications.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To perform analysis and improvement of our products and services.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To personalize our products and services.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To detect and manage security risks.
      </p>

      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To allow you to participate in interactive features on our Website.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To count and track referrals and ads.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To identify or authenticate your access and use of the Website.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        For our employees, to facilitate their employment and facilitate payroll and other HR
        functions.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        In any other way we may describe when you provide the information.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        For any other purpose with your consent.
      </p>
      <p className="Paragraph">
        We may also use your information, if you have opted into our marketing lists, to contact you
        about our own and third-parties’ goods and services that may be of interest to you. For more
        information, see{' '}
        <u>
          <span style={{ color: '#002060' }}>
            <a href="#a741158">
              <u>
                <span style={{ color: '#002060' }}>
                  Choices About How We Use and Disclose Your Information
                </span>
              </u>
            </a>
          </span>
        </u>
        .
      </p>
      <p className="Paragraph">
        We may use the information we have collected from you to enable us to display advertisements
        to our advertisers’ target audiences. Even though we do not disclose your personal
        information for these purposes without your consent, if you click on or otherwise interact
        with an advertisement, the advertiser may assume that you meet its target criteria.
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a998196">
          <u>
            <span style={{ fontSize: '14.0pt' }}>Disclosure of Your Information</span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        We may disclose aggregated information about our users, and information that does not
        identify any individual, without restriction.{' '}
      </p>
      <p className="Paragraph">
        We may disclose personal information that we collect or you provide as described in this
        privacy policy:
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To our subsidiaries and affiliates.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To service providers we use to support our business including payment processors and
        notifications services such as email and sms service providers.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To a buyer or other successor in the event of a merger, divestiture, restructuring,
        reorganization, dissolution, or other sale or transfer of some or all of GigSocial Inc.’s
        assets, whether as a going concern or as part of bankruptcy, liquidation, or similar
        proceeding, in which personal information held by GigSocial Inc. about our Website users is
        among the assets transferred.
      </p>
      <p className="BulletList1">
        <u>
          <span style={{ color: '#002060' }}>
            <a href="#a741158">
              <u>
                <span style={{ color: '#002060' }}>
                  Choices About How We Use and Disclose Your Information
                </span>
              </u>
            </a>
          </span>
        </u>
        .
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To fulfill the purpose for which you provide it.{' '}
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        For any other purpose disclosed by us when you provide the information.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        With your consent.
      </p>
      <p className="Paragraph">We may also disclose your personal information:</p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To comply with any court order, law, or legal process, including to respond to any
        government or regulatory request.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        To enforce or apply our terms of use and other agreements.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        If we believe disclosure is necessary or appropriate to protect the rights, property, or
        safety of GigSocial Inc., our customers, or others. This includes exchanging information
        with other companies and organizations for the purposes of fraud protection and credit risk
        reduction.
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a741158">
          <u>
            <span style={{ fontSize: '14.0pt' }}>
              Choices About How We Use and Disclose Your Information
            </span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        We strive to provide you with choices regarding the personal information you provide to us.
        We have created mechanisms to provide you with the following control over your information:{' '}
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <b>Tracking Technologies and Advertising.</b> You can set your browser to refuse all or some
        browser cookies, or to alert you when cookies are being sent. If you disable or refuse
        cookies, please note that some parts of this site may then be inaccessible or not function
        properly.
      </p>
      <p className="BulletList1">
        <span style={{ fontFamily: 'Symbol' }}>
          ·
          <span style={{ font: '7.0pt "Times New Roman"' }}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
        <b>Promotional Offers from the Company.</b> If you do not wish to have your email address
        used by Us to promote our own or third parties’ products or services, you can opt-out by
        sending us an email stating your request to support@gigsocial.com. If we have sent you a
        promotional email, you may send us a return email asking to be omitted from future email
        distributions.{' '}
      </p>
      <p className="Paragraph">
        California residents may have additional personal information rights and choices. Please see{' '}
        <u>
          <span style={{ color: '#002060' }}>
            <a href="#a820658">
              <u>
                <span style={{ color: '#002060' }}>Your California Privacy Rights</span>
              </u>
            </a>
          </span>
        </u>
        for more information.
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a820658">
          <u>
            <span style={{ fontSize: '14.0pt' }}>Your California Privacy Rights</span>
          </u>
        </a>
      </p>
      <p className="Paragraph">
        This section&nbsp;applies solely to all visitors, users, and others who reside in the State
        of California (“consumers” or “you”). We adopt this notice to comply with the California
        Consumer Privacy Act of 2018 (CCPA) and any terms defined in the CCPA have the same meaning
        when used in this notice.
      </p>
      <p className="Paragraph">
        <b>Information We Collect</b>
      </p>
      <p className="Paragraph">
        Our Website collects information that identifies, relates to, describes, references, is
        capable of being associated with, or could reasonably be linked, directly or indirectly,
        with a particular consumer or device (“<b>Personal Information</b>”). We have collected the
        following categories of personal information from consumers within the last twelve (12)
        months:
      </p>
      <table
        className="MsoNormalTable"
        border={1}
        cellSpacing={0}
        cellPadding={0}
        width="100%"
        style={{ width: '100.0%', background: 'white', borderCollapse: 'collapse', border: 'none' }}
      >
        <tbody>
          <tr>
            <td valign="top" style={{ border: 'solid #E9ECEF 1.0pt', padding: '0in 0in 0in 0in' }}>
              <p
                align="center"
                style={{ marginTop: '0in', textAlign: 'center', lineHeight: '21.6pt' }}
              >
                <strong>Category</strong>
              </p>
            </td>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderLeft: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p
                align="center"
                style={{ marginTop: '0in', textAlign: 'center', lineHeight: '21.6pt' }}
              >
                <strong>Examples</strong>
              </p>
            </td>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderLeft: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p
                align="center"
                style={{ marginTop: '0in', textAlign: 'center', lineHeight: '21.6pt' }}
              >
                <strong>Collected</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>Identifiers.</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  A real name, alias, postal address, unique personal identifier, online identifier,
                  Internet Protocol address, email address, account name, Social Security number,
                  driver’s license number, passport number, or other similar identifiers.
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;Yes</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Personal information categories listed in the California Customer Records statute
                  (Cal. Civ. Code § 1798.80(e)).
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  A name, signature, Social Security number, physical characteristics or
                  description, address, telephone number, passport number, driver’s license or state
                  identification card number, insurance policy number, education, employment,
                  employment history, bank account number, credit card number, debit card number, or
                  any other financial information, medical information, or health insurance
                  information.
                </span>
              </p>
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Some personal information included in this category may overlap with other
                  categories.
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;Yes</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Protected classification characteristics under California or federal law.
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Age (40 years or older), race, color, ancestry, national origin, citizenship,
                  religion or creed, marital status, medical condition, physical or mental
                  disability, sex (including gender, gender identity, gender expression, pregnancy
                  or childbirth and related medical conditions), sexual orientation, veteran or
                  military status, genetic information (including familial genetic information).
                </span>
              </p>
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;YES</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}> Commercial information.</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Records of personal property, products or services purchased, obtained, or
                  considered, or other purchasing or consuming histories or tendencies.
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;Yes</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>Biometric information.</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            ></td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;No</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>Internet or other similar network activity.</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Browsing history, search history, information on a consumer’s interaction with our
                  website, application, or advertisement.
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;Yes</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>Geolocation data.</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>Physical location or movements.</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;No</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>Sensory data.</span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            ></td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;No</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            ></td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            ></td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            ></td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            ></td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;</span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              style={{
                border: 'solid #E9ECEF 1.0pt',
                borderTop: 'none',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Inferences drawn from other personal information.
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>
                  Profile reflecting a person’s preferences, characteristics, psychological trends,
                  predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.
                </span>
              </p>
            </td>
            <td
              valign="top"
              style={{
                borderTop: 'none',
                borderLeft: 'none',
                borderBottom: 'solid #E9ECEF 1.0pt',
                borderRight: 'solid #E9ECEF 1.0pt',
                padding: '0in 0in 0in 0in',
              }}
            >
              <p style={{ marginTop: '0in' }}>
                <span style={{ color: 'black' }}>&nbsp;No</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We obtain the categories of personal information listed above from the following
          categories of sources:
        </span>
      </p>
      <ul type="disc">
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Directly from you when you provide it to us;
            <br />
            <br />
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Automatically as you use the Website. Automatically collected information may include
            usage details, IP addresses, and information collected through cookies, web beacons, and
            other tracking technologies; and
            <br />
            <br />
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            From third parties, such as our business partners.
          </span>
        </li>
      </ul>
      <p className="MsoNormal" style={{ background: 'white' }}>
        <b>
          <span style={{ fontFamily: '"Times New Roman",serif' }}>Use of Personal Information</span>
        </b>
      </p>
      <p className="Abstract">
        In addition to our description of how we use data elsewhere in this policy, we may use or
        disclose the personal information we collect for one or more of the following business
        purposes:
      </p>
      <ul type="disc">
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To fulfill or meet the reason you provided the information.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To provide, support, personalize, and develop our Website, products, and services.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To create, maintain, customize, and secure your account with us.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To process your requests.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To provide you with support and to respond to your inquiries, including to investigate
            and address your concerns and monitor and improve our responses.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To personalize your Website experience and to deliver content and product and service
            offerings relevant to your interests, including targeted offers through our Website,
            third-party sites, and via email or text message (with your consent, where required by
            law).
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To help maintain the safety, security, and integrity of our Website, products and
            services, databases and other technology assets, and business.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            For testing, research, analysis, and product development, including to develop and
            improve our Website, products, and services.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To respond to law enforcement requests and as required by applicable law, court order,
            or governmental regulations.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            As described to you when collecting your personal information or as otherwise set forth
            in the CCPA.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            To evaluate or conduct a merger, divestiture, restructuring, reorganization,
            dissolution, or other sale or transfer of some or all of our&nbsp;assets, whether as a
            going concern or as part of bankruptcy, liquidation, or similar proceeding, in which
            personal information held by us&nbsp;about our Website users is among the assets
            transferred.
          </span>
        </li>
      </ul>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We value protecting our consumers information and we will not collect additional
          categories of personal information or use the personal information we collected for
          materially different, unrelated, or incompatible purposes without providing you notice.
        </span>
      </p>
      <p className="MsoNormal" style={{ background: 'white' }}>
        <b>
          <span style={{ fontFamily: '"Times New Roman",serif' }}>Your Rights and Choices</span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          The CCPA provides consumers (California residents) with specific rights regarding their
          personal information. This section describes your CCPA rights and explains how to exercise
          those rights if they are applicable to you.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <b>
          <span style={{ color: 'black' }}>
            Access to Specific Information and Data Portability Rights
          </span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          Once we receive and confirm your verifiable request, we will, unless an exception applies,
          disclose to you:
        </span>
      </p>
      <ul type="disc">
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            The categories of personal information we collected about you.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            The categories of sources for the personal information we collected about you.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Our business or commercial purpose for collecting that personal information.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            The categories of third parties with whom we utilize that may securely store your
            personal information, but not access for their business.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            The specific pieces of personal information we collected about you.
          </span>
        </li>
      </ul>
      <p className="MsoNormal" style={{ background: 'white' }}>
        <b>
          <span style={{ fontFamily: '"Times New Roman",serif' }}>Deletion Request Rights</span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          You have the right to request that we delete from our records any of the personal
          information that&nbsp;we collect and retained, subject to certain exceptions. Once we
          receive and confirm your verifiable request, we will delete&nbsp;your personal information
          from our records, unless an exception applies.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <b>
          <span style={{ color: 'black' }}>Why We May Deny Your Request</span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We may deny your deletion request if retaining the information is necessary for us or our
          service provider(s) to:
        </span>
      </p>
      <ol start={1} type={1}>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Complete the transaction for which we collected the personal information.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Provide you with notices about your account, including expiration and renewal notices.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Carry out our obligations and enforce our rights arising from any contracts entered into
            between you and us.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Fulfill any other purpose for which you provided it.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal
            activity, or prosecute those responsible for such activities.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Debug products to identify and repair errors that impair existing intended
            functionality.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Exercise free speech, ensure the right of another consumer to exercise their free speech
            rights, or exercise another right provided for by law.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Comply with the California Electronic Communications Privacy Act (Cal. Penal Code §
            1546&nbsp;<em>et. seq.</em>).
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Engage in public or peer-reviewed scientific, historical, or statistical research in the
            public interest that adheres to all other applicable ethics and privacy laws, when the
            information’s deletion may likely render impossible or seriously impair the research’s
            achievement, if you previously provided informed consent.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Enable solely internal uses that are reasonably aligned with consumer expectations based
            on your relationship with us.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Comply with a legal obligation and any&nbsp;relevant laws, regulations, ordinances,
            rules, directives, or statutes.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Make other internal and lawful uses of that information that are compatible with the
            context in which you provided it.
          </span>
        </li>
      </ol>
      <p className="MsoNormal" style={{ background: 'white' }}>
        <b>
          <span style={{ fontFamily: '"Times New Roman",serif' }}>
            Exercising Access, Data Portability, and Deletion Rights
          </span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          To exercise the access, data portability, and deletion rights described above, please
          submit a verifiable consumer request to us by filling out&nbsp;
          <a>
            <span>this form</span>
          </a>
        </span>
        <span style={{ color: 'black' }}>
          &nbsp;or&nbsp;emailing your request to&nbsp;support@gigsocial.com.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <b>
          <span style={{ color: 'black' }}>What We May Need From You</span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We may need to request specific information from you to help us confirm your identity and
          ensure your right to access your personal data (or to exercise any of your other rights).
          This is a security measure to ensure that personal data is not disclosed to any person who
          has no right to receive it. We may also contact you to ask you for further information in
          relation to your request to speed up our response.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          Only you, or a person registered with the California Secretary of State that you authorize
          to act on your behalf, may make a verifiable consumer request related to your personal
          information. You may also make a verifiable consumer request on behalf of your minor
          child.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          You may only make a verifiable consumer request for access or data portability twice
          within a 12-month period. The verifiable consumer request must:
        </span>
      </p>
      <ul type="disc">
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Provide sufficient information that allows us to reasonably verify you are the person
            about whom we collected personal information or an authorized representative.
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Describe your request with sufficient detail that allows us to properly understand,
            evaluate, and respond to it.
          </span>
        </li>
      </ul>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We cannot respond to your request or provide you with personal information if we cannot
          verify your identity or authority to make the request and confirm the personal information
          relates to you.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          Making a verifiable consumer request does not require you to create an account with
          us.&nbsp;We will only use personal information provided in a verifiable consumer request
          to verify the requestor’s identity or authority to make the request.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>&nbsp;</p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <b>
          <span style={{ color: 'black' }}>Response Timing and Format</span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We endeavor to respond to a verifiable consumer request within forty-five (45) days of its
          receipt. If we require more time (up to 90 additional&nbsp;days), we will inform you of
          the reason and extension period in writing.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          If you have an account with us, we will deliver our written response to that account. If
          you do not have an account with us, we will deliver our written response by mail or
          electronically, at your option.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          Any disclosures we provide will only cover the 12-month period preceding the verifiable
          consumer request’s receipt. The response we provide will also explain the reasons we
          cannot comply with a request, if applicable. For data portability requests, we will select
          a format to provide your personal information that is readily useable and should allow you
          to transmit the information from one entity to another entity without hindrance.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <b>
          <span style={{ color: 'black' }}>Fees</span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We do not charge a fee to process or respond to your verifiable consumer request unless it
          is excessive, repetitive, or manifestly unfounded. If we determine that the request
          warrants a fee, we will tell you why we made that decision and provide you with a cost
          estimate before completing your request.
        </span>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <b>
          <span style={{ color: 'black' }}>Non-Discrimination</span>
        </b>
      </p>
      <p style={{ marginTop: '0in', background: 'white' }}>
        <span style={{ color: 'black' }}>
          We will not discriminate against you for exercising any of your CCPA rights. Unless
          permitted by the CCPA, we will not:
        </span>
      </p>
      <ul type="disc">
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Deny you goods or services;
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Charge you, or suggest you may be charged, for services;
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Impose penalties;
          </span>
        </li>
        <li className="MsoNormal" style={{ color: 'windowtext', background: 'white' }}>
          <span style={{ fontFamily: '"Times New Roman",serif', color: 'black' }}>
            Provide you a different level or quality of services.
          </span>
        </li>
      </ul>
      <p className="Paragraph">
        California’s “Shine the Light” law (Civil Code Section § 1798.83) permits users of our
        Website that are California residents to request certain information regarding our
        disclosure of personal information to third parties for their direct marketing purposes. To
        make such a request, please send an email to support@gigsocial.com.
      </p>
      {/* Copy pending legal review */}
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a_payment_card_storage">
          <u>Payment Card Storage and Merchant-Initiated Charges</u>
        </a>
      </p>
      <p className="Paragraph">
        When you place an order, your payment card is securely stored (tokenized) by our
        PCI-compliant payment processor. We do not store full card numbers on our servers. Your
        card is charged as deliverables are approved, per the order terms. You can remove saved
        cards in Settings → Payment Methods; cards backing active orders are retained until the
        order completes.
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a539528">
          <u>Data Security</u>
        </a>
      </p>
      <p className="Paragraph">
        We have implemented measures designed to secure your personal information from accidental
        loss and from unauthorized access, use, alteration, and disclosure.{' '}
      </p>
      <p className="Paragraph">
        Unfortunately, the transmission of information via the internet is not completely secure.
        Although we do our best to protect your personal information, we cannot guarantee the
        security of your personal information transmitted to our Website. Any transmission of
        personal information is at your own risk. We are not responsible for circumvention of any
        privacy settings or security measures contained on the Website.{' '}
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a286592">
          <u>Changes to Our Privacy Policy</u>
        </a>
      </p>
      <p className="Paragraph">
        It is our policy to post any changes we make to our privacy policy on this page with a
        notice that the privacy policy has been updated on the Website home page. If we make
        material changes to how we treat our users’ personal information, we will notify you through
        a notice on the Website home page. The date the privacy policy was last revised is
        identified at the top of the page. You are responsible for ensuring we have an up-to-date
        active and deliverable email address for you, and for periodically visiting our Website and
        this privacy policy to check for any changes.
      </p>
      <p className="CustomizableHeading" align="left" style={{ textAlign: 'left' }}>
        <a name="a955470">
          <u>Contact Information</u>
        </a>
      </p>
      <p className="Paragraph">
        To ask questions or comment about this privacy policy and our privacy practices, contact us
        at:{' '}
      </p>
      <p className="Paragraph">support@gigsocial.com.</p>
    </div>
  </div>
);

export default Privacy;
